import React, { useState } from "react";
import { Button,  Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { AuthService } from "../../services";
import { injectModels } from "../../redux/injectModels";
import { handleConsoleError } from "../../utils/common-methods";

function Profile(props) {
  const loginUser = useSelector((state) => state?.auth?.user);
  const [validated, setValidated] = useState(false);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const handleSubmit = async (event) => {
    const form = event?.currentTarget;
    event.preventDefault();
    setValidated(true);
    if (form.checkValidity() === false || newPassword !== confirmNewPassword) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    try {
      props.application.setLoading(true);
      const data = {
        id: "",
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmPassword: confirmNewPassword,
      };
      const res = await AuthService.changePasswordAdmin(data);
      if (res?.isSuccess) {
        props.application.setLoading(false);
        toast.success(res?.message);
      } else {
        toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    } catch (err) {
      const message=handleConsoleError(err);
      props.application.setLoading(false);
      toast.error(err?.message || message);
    }
  };

  return (
    <React.Fragment>
      <div className="table-responsive">
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            columnGap: 20,
            overflow: "hidden",
            marginBottom: 10,
          }}
        >
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            style={{ flex: 1 }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: 10,
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  width: 50,
                  height: 50,
                  borderRadius: 25,
                  border: "3px solid #ec2e7a",
                  overflow: "hidden",
                  alignItems: "center",
                }}
              >
                <img
                  style={{ width: 44, height: 44 }}
                  alt=""
                  src={
                    loginUser?.avatar ??
                    "/assets/images/users/user-dummy-img.jpg"
                  }
                ></img>
              </div>
              <div>
                <h4
                  style={{ marginBottom: 0 }}
                >{`${loginUser?.firstName} ${loginUser?.lastName}`}</h4>
                <h6>{`${loginUser?.email}`}</h6>
              </div>
            </div>
            <div style={{ marginTop: 30 }}>
              <h2>Change password</h2>
              <div style={{ padding: 10 }}>
                <Row className="mb-3">
                  <Form.Group controlId="formGridBasics">
                    <Form.Label>Old password</Form.Label>
                    <Form.Control
                      defaultValue={oldPassword}
                      required
                      placeholder="Enter old password"
                      onChange={(e) => {
                        setOldPassword(e.target.value);
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Old password is required
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group controlId="formGridBasics">
                    <Form.Label>New password</Form.Label>
                    <Form.Control
                      defaultValue={newPassword}
                      required
                      isInvalid={
                        newPassword.length > 0 && newPassword.length < 6
                      }
                      placeholder="Enter new password"
                      onChange={(e) => {
                        setNewPassword(e.target.value);
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {newPassword.length === 0
                        ? "New password is required"
                        : "New password should be at least 6 characters long"}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group controlId="formGridBasics">
                    <Form.Label>Confirm new password</Form.Label>
                    <Form.Control
                      defaultValue={confirmNewPassword}
                      placeholder="Enter confirm password"
                      required
                      isInvalid={newPassword !== confirmNewPassword}
                      onChange={(e) => {
                        setConfirmNewPassword(e.target.value);
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {confirmNewPassword.length > 0
                        ? "Confirm password should match to new password"
                        : "Confirm password is required"}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Button variant="primary" type="submit">
                  Submit
                </Button>
              </div>
            </div>
          </Form>
          <div style={{ flex: 1 }}></div>
        </div>
      </div>
    </React.Fragment>
  );
}
export default injectModels(["admin", "application"])(Profile);
